import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService } from 'src/environments/app-config.service';
import {
  WithdrawalModalAction,
  WithdrawalResultModalViewModel,
} from './withdrawal-result-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-success-retirement',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-success-retirement.component.html',
  styleUrls: ['./modal-success-retirement.component.scss'],
})
export class ModalSuccessRetirementComponent {
  @Input() open = false;
  @Input() viewModel: WithdrawalResultModalViewModel = {
    mode: 'success',
    heading: 'Sucesso!',
    icon: 'check_circle',
    iconTone: 'success',
    bodyText: 'Aposentadoria dos créditos foi realizada com sucesso.',
  };

  @Output() action = new EventEmitter<WithdrawalModalAction>();

  private supportUrl = '';

  constructor(appConfig: AppConfigService) {
    this.supportUrl = appConfig.config?.urlSuporteB3 ?? 'https://atendimento.b3.com.br/atendeb3';
  }

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onNewWithdrawal(): void {
    this.action.emit('clear');
  }

  onConsultOperation(): void {
    this.action.emit('consult');
  }

  onRetry(): void {
    this.action.emit('retry');
  }

  onSupport(): void {
    if (this.supportUrl) {
      window.open(this.supportUrl, '_blank');
    }
    this.action.emit('dismiss');
  }
}
